export default __webpack_public_path__ + "static/media/part_2_img_why.306f4bd4.png";